import { HostBinding, Directive } from '@angular/core';

@Directive({
  selector: '[searchResponsiveUi]'
})
export class SearchResponsiveUi {
  @HostBinding('class')
  elementClass = 'ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-8 ant-col-xxl-8';
}
